import { Component, Input } from "@angular/core"
import { ColorPaletteService } from "@shared/services/color-palette.service"
import { AgColor } from "../flow-badge/flow-badge.component"

@Component({
  selector: "flow-divider-component",
  standalone: false,
  templateUrl: "./flow-divider.component.html",
  styleUrl: "./flow-divider.component.scss",
})
export class FlowDividerComponent {
  @Input() width: string = "100%"
  @Input() height: string = "1px"
  @Input() color: AgColor = "Neutral"

  constructor(private colorService: ColorPaletteService) {}

  public getBackgroundColor(): string {
    switch (this.color) {
      case "Neutral":
        return this.colorService.neutral200
      case "Blue":
        return this.colorService.blue200
      case "Green":
        return this.colorService.green200
      case "Yellow":
        return this.colorService.yellow200
      case "Orange":
        return this.colorService.orange200
      case "Purple":
        return this.colorService.purple200
      case "Red":
        return this.colorService.red200
    }
  }
}
